import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { FavoriteMarketsCategory } from 'shared/src/api/favoriteMarketService/getFavoriteMarketsFilterOptions/types';

type LogApplyCategoryChipFilterParams = {
  category: FavoriteMarketsCategory | null;
};

export const useLogApplyCategoryChipFilter = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ category }: LogApplyCategoryChipFilterParams) => {
      logAnalyticsEvent({
        name: 'APPLY_CATEGORY_CHIP_FILTER',
        analytics: {
          CATEGORY_SNO: category?.sno.toString() ?? '-1',
          CATEGORY_NAME: category?.name ?? '전체',
        },
      });
    },
    [logAnalyticsEvent],
  );
};
